import TextClient from './clients/TextClient'

export default {
  get () {
    return TextClient.get()
  }
}
